import { debounce } from 'lodash-es';
import { useEffect, useMemo, useState } from 'react';

export const useDebouncedValue = <T>(value: T, delay: number): T => {
  const [debouncedValue, setDebouncedValue] = useState(value);

  const setDebouncedValueAfterDelay = useMemo(
    () => debounce((newValue: T) => setDebouncedValue(newValue), delay),
    [delay],
  );

  useEffect(() => {
    setDebouncedValueAfterDelay(value);
    return () => {
      setDebouncedValueAfterDelay.cancel();
    };
  }, [value, setDebouncedValueAfterDelay]);

  return debouncedValue;
};
